import axios, { post } from 'axios';
import { HOST } from "common-import/constants";
const qs = require('qs');

class RequestHelper {
  getToken = () => {
    return window.store.userStore.getToken();
  }

  makeHeader = method => {
    let token = this.getToken();
    let headers = {};
    if(token != undefined) headers["Authorization"] = token;
    if(method == "POST") headers["Content-Type"] = "application/json";
    return headers;
  }

  querify = (url, queryObject) => {
    let newUrl = url;
    if(queryObject == undefined) return newUrl;
    newUrl += "?" + qs.stringify(queryObject);
    return newUrl;
  }

  upload = async (file) => {
    const url = HOST+ '/uploads';
    const formData = new FormData();
    formData.append('file',file);
    const config = {
      headers: {
          'content-type': 'multipart/form-data',
          'Authorization': this.getToken()
      }
    }
    const { data } = await post(url, formData,config);
    const uploadedUrl = HOST + data.url;
    return uploadedUrl;
  }

  post = async (URL, bodyObject) => {
    return fetch(URL, {
      method: "POST",
      headers: this.makeHeader("POST"),
      body: JSON.stringify(bodyObject)
    })
  }

  get = async (URL, queryObject) => {
    const urlWithQuery = this.querify(URL, queryObject)
    return fetch(urlWithQuery, {
      method: "GET",
      headers: this.makeHeader("GET")
    })
  }

  isValidResponse = () => {
    return true;
  }

  handleInvalidResponse = async () => {
    return
  }
}

export default new RequestHelper();


// WEBPACK FOOTER //
// ./src/utils/RequestHelper.js